import { ImportExportHistories } from '@/features/import_export_histories';
import { FC, memo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const ImportExportHistoriesCustomTransactionItemsPage: FC = memo(() => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  return (
    <ImportExportHistories location={location} searchParams={searchParams} />
  );
});

ImportExportHistoriesCustomTransactionItemsPage.displayName =
  'ImportExportHistoriesCustomTransactionItemsPage';

export default ImportExportHistoriesCustomTransactionItemsPage;
